import { PlusIcon, SettingsIcon } from 'lucide-react'

import type {
  AgentItemActions,
  ChatItemActions,
  ChatItemEditState,
  // TODO: ProjectItemActions temporarily unused - Projects hidden
  // ProjectItemActions,
} from './sidebar-item-actions.interface'
import type { SidebarNavGroup, SidebarNavItem } from './sidebar-nav-item.interface'

export interface BuildNavGroupsParams {
  isPathActive: (path: string) => boolean
  // TODO: handleCreateProject temporarily unused - Projects hidden
  // handleCreateProject: () => void
  handleAgenciesSettings: () => void
  handleCreateChat: () => void
  // TODO: projectActions temporarily unused - Projects hidden
  // projectActions: ProjectItemActions
  agentActions: AgentItemActions
  chatActions: ChatItemActions
  chatEditState?: ChatItemEditState
  pinnedConversationItemList: SidebarNavItem[]
  conversationItemList: SidebarNavItem[]
  agencyItemList: SidebarNavItem[]
}

const markActiveItems = (
  itemList: SidebarNavItem[],
  isPathActive: (path: string) => boolean
): SidebarNavItem[] => itemList.map((item) => ({ ...item, isActive: isPathActive(item.path) }))

export const buildNavGroups = ({
  isPathActive,
  // TODO: handleCreateProject temporarily unused - Projects hidden
  // handleCreateProject,
  handleAgenciesSettings,
  handleCreateChat,
  // TODO: projectActions temporarily unused - Projects hidden
  // projectActions,
  agentActions,
  chatActions,
  chatEditState,
  pinnedConversationItemList,
  conversationItemList,
  agencyItemList,
}: BuildNavGroupsParams): SidebarNavGroup[] => {
  const groupList: SidebarNavGroup[] = [
    // TODO: Projects group temporarily hidden - code preserved below
    // {
    //   label: 'Projects',
    //   items: mockProjects.map((project) => ({
    //     ...project,
    //     isActive: isPathActive(project.path),
    //   })),
    //   action: { icon: PlusIcon, tooltip: 'Create project', onClick: handleCreateProject },
    //   maxVisible: 5,
    //   itemType: 'project',
    //   projectActions,
    // },
    {
      label: 'Agencies',
      items: markActiveItems(agencyItemList, isPathActive),
      action: { icon: SettingsIcon, tooltip: 'Agency settings', onClick: handleAgenciesSettings },
      maxVisible: 5,
      itemType: 'agent',
      agentActions,
    },
  ]

  if (pinnedConversationItemList.length > 0) {
    groupList.push({
      label: 'Pinned',
      items: markActiveItems(pinnedConversationItemList, isPathActive),
      itemType: 'chat',
      chatActions,
      chatEditState,
    })
  }

  if (conversationItemList.length > 0) {
    groupList.push({
      label: 'Chats',
      items: markActiveItems(conversationItemList, isPathActive),
      action: { icon: PlusIcon, tooltip: 'New chat', onClick: handleCreateChat },
      itemType: 'chat',
      chatActions,
      chatEditState,
    })
  }

  return groupList
}
